import Icon from "../Icon";
import LinkComp from "../LinkComp";
import * as React from "react";

export default ({pipelineLinks, name, isSidebarOpen, isPipelineOpen, svg, svgChevron, path, handleCollapsePipeline, onLinkHover}) => {
    const isAnyPipelineActive = pipelineLinks.find(el => el.url === path);
    return (
        <React.Fragment>
            <li className={`Sidebar_item strive-pipeline first-strive-pipeline ${isPipelineOpen ? "" : "closed-first-strive-pipeline"}`}
                onMouseOver={onLinkHover}>
                <div className="item-wrapper">
                    <div className={`Sidebar_item_link ${isAnyPipelineActive ? "Sidebar_item_link--active" : ""}`}
                         onClick={handleCollapsePipeline}>
                        <Icon svg={svg}/>
                        <div className="Sidebar_item_link_name">{name}</div>
                        {isSidebarOpen && (
                            <Icon 
                                svg={svgChevron} 
                                className={`chevron-icon ${isPipelineOpen ? "chevron-expanded" : ""}`} 
                            />
                        )}
                    </div>
                    {
                        isSidebarOpen ?
                            null
                            :
                            <span className="tooltip">{name}</span>
                    }
                </div>
            </li>
            {
                pipelineLinks.map((link, index) => (
                    <li className={`Sidebar_item strive-pipeline ${index === pipelineLinks.length - 1 ? "last-strive-pipeline" : ""} ${isPipelineOpen ? "" : "closed-strive-pipeline"}`}
                        key={index}
                        onMouseOver={onLinkHover}>
                        <div className="item-wrapper">
                            <LinkComp className={`Sidebar_item_link ${isSidebarOpen ? "" : "closed-sidebar"}${link.url === path ? " Sidebar_item_link--active" : ""}`}
                                      to={arc.path.base + link.url}>
                                <Icon svg={link.svg} className={link.className} />
                                <div className="Sidebar_item_link_name">{link.name}</div>
                            </LinkComp>
                            {
                                isSidebarOpen ?
                                    null
                                    :
                                    <span className="tooltip">{link.name}</span>
                            }
                        </div>
                    </li>
                ))
            }
        </React.Fragment>
    )
}